import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconTwitter = props => {
  if (props.id !== "_svgicontwitter") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="8 8 32 32" {...props}><path d="M24 8C15.163 8 8 15.163 8 24s7.163 16 16 16 16-7.163 16-16S32.837 8 24 8zm8.29 12.293c.008.173.012.347.012.522 0 5.338-4.063 11.493-11.493 11.493-2.28 0-4.404-.67-6.191-1.815.316.037.637.056.963.056a8.104 8.104 0 005.017-1.729 4.044 4.044 0 01-3.774-2.805 4.03 4.03 0 001.825-.069 4.042 4.042 0 01-3.24-3.96v-.051a4.023 4.023 0 001.83.505 4.037 4.037 0 01-1.798-3.362c0-.74.2-1.434.547-2.03a11.467 11.467 0 008.326 4.22 4.04 4.04 0 016.883-3.684 8.088 8.088 0 002.565-.98 4.05 4.05 0 01-1.776 2.234 8.068 8.068 0 002.32-.636 8.206 8.206 0 01-2.016 2.09z" /></svg>;
};

SvgIconTwitter.displayName = "_svgicontwitter";
SvgIconTwitter.propTypes = {
  id: PropTypes.string
};
SvgIconTwitter.defaultProps = {
  id: ''
};
export default SvgIconTwitter;